/*eslint-disable*/
import { HonestSelectInput } from '../../../components/HonestSelect/HonestSelectInput'
import { Input } from '../../../components/Input/Input'
import { Animation, Button, ButtonsContainer, Flex, ItemsGrid, Separator, TabFooter } from '../../../styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { ISelectValue } from 'constants/globalTypes'
import { IItemsTab } from 'types/inventory.interface'
import { depreciationMethodOptions } from './itemsData'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'

export const InventoryItemsFinancialTab = ({
  state,
  setState,
  setActive,
}: IItemsTab) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const handleSelect = async (value: ISelectValue, name: string) => {
    setState(prev => ({ ...prev, [name]: value }))
  }

  const handleNext = () => {
    setActive('Storage')
  }

  const handleCheckbox = (name: string) => {
    setState(prev => ({ ...prev, [name]: !prev[name] }))
  }

  return (
    <Animation>

      <Flex column width='100%' >
        <ItemsGrid columns={3} gap='0 1.5rem'>

          <Input
            value={state?.glAssetCode}
            name='glAssetCode'
            onChange={handleChange}
            placeholder='123456'
            labelText='GL Asset Code'
          />

          <Input
            value={state?.glExpenseCode}
            name='glExpenseCode'
            onChange={handleChange}
            placeholder='123456'
            labelText='GL Expense Code'
          />

          <HonestSelectInput
            onChange={handleSelect}
            options={depreciationMethodOptions}
            name='depreciationMethod'
            defaultValue={state?.depreciationMethod?.value}
            labelText='Depreciation Method'
          />

          <HonestSelectAsyncInput
            link='inventory/cost-center'
            name='costCenter'
            labelText='Cost Center'
            placeholder='Select Cost Center'
            defaultValue={state?.costCenter?.label}
            onChange={handleSelect}
            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
            nomarg
          />
        </ItemsGrid>
        <Separator />
        <Flex gap='1rem' mb='16' >
          <CheckBox state={state?.taxDeductible} title='Tax Deductible' square onClick={() => handleCheckbox('taxDeductible')} />
          <CheckBox state={state?.depreciable} title='Depreciable' square onClick={() => handleCheckbox('depreciable')} />
        </Flex>
      </Flex>



      <TabFooter >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
